module.exports = __webpack_public_path__ + "logo-fallback.png?38007a5667cc9eb6f17bec55d8675954";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-fallback.png
// module id = 707
// module chunks = 0